import React, {useMemo} from 'react';
import useApiCall from "../hooks/useApiCall";
import {backendEndpoints} from "../../libs/backendEndpoints";
import {Alert, Button, Cookies} from "fearless-common-ui";
import { Person } from 'react-bootstrap-icons';
import useAuth, {adminTokenKey} from "../hooks/useAuth";
import {routes} from "../../utils";

/**
 * Button to emulate the current website session as another user.
 *
 * @param userId User to emulate.
 */
export default function LogInAsUserButton({ userId }: { userId: number }) {
  const { saveToken, reinstateAdminToken } = useAuth();
  const { onSubmit, error, isSubmitting } = useApiCall({
    url: backendEndpoints.logInAs(),
    method: 'post',
  });

  const inEmulation = useMemo(() => {
    return Boolean(Cookies.get(adminTokenKey));
  }, []);

  return (
    <>
      {error && <Alert>{error}</Alert>}
      {inEmulation ? (
        <Button variant="primary" onClick={() => reinstateAdminToken()}>
          Cancel emulation
        </Button>
      ) : (
        <Button
          variant="primary"
          icon={<Person />}
          isDoing={isSubmitting}
          onClick={() => onSubmit({ user_id: userId }).then((result) => {
            if (result.token && typeof result.token === 'string') {
              saveToken(result.token, true);
              window.location.href = routes.landing;
              return result;
            } else {
              throw new Error('Returned data format incorrect');
            }
          })}
        >
          Log in as
        </Button>
      )}
    </>
  );
}
